import { Color, Flex, Text } from '@billy/design-system'
import React from 'react'

import { DotToCheckmark } from '../../../DotToCheckmark'
import { StepState } from '../../types'
import * as Styled from './styles'
import { getStepState } from './utils/getStepState'

interface ProgressBarProps {
  currentStep?: number
  totalSteps?: number
  stepLabels?: string[]
}

export const ProgressBar = ({ currentStep, totalSteps, stepLabels }: ProgressBarProps) => {
  if (currentStep === undefined || totalSteps === undefined || stepLabels === undefined) {
    return null
  }

  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1)

  return (
    <Flex alignItems="center" justifyContent="center" width="100%">
      {steps.map((step) => {
        const stepState = getStepState({ step, currentStep })

        return (
          <React.Fragment key={step}>
            <Styled.StepContainer>
              <DotToCheckmark
                isSuccess={stepState === StepState.Completed}
                isAnimated={step === currentStep - 1}
                isUpcoming={stepState === StepState.Upcoming}
              />
              <Styled.StepLabel>
                <Text
                  variant="bodySM"
                  weight="bold"
                  color={stepState !== StepState.Upcoming ? Color.Black : Color.Grey200}
                >
                  {stepLabels[step - 1]}
                </Text>
              </Styled.StepLabel>
            </Styled.StepContainer>
            {step < totalSteps && <Styled.ProgressSeparator isActive={step < currentStep} />}
          </React.Fragment>
        )
      })}
    </Flex>
  )
}
